export function PaymentLoadingSkeleton() {
  return (
    <>
      <div className="grid grid-cols-4 gap-4">
        <div className="col-span-4 sm:col-span-2">
          <div className="w-1/5 h-3.5 mb-2 bg-gray-400/60 dark:bg-gray-400/30  rounded" />
          <div className="rounded bg-gray-400/60 dark:bg-gray-400/30 h-11" />
        </div>
        <div className="col-span-2 sm:col-span-1">
          <div className="w-1/5 h-3.5 mb-2 bg-gray-400/60 dark:bg-gray-400/30  rounded" />
          <div className="rounded bg-gray-400/60 dark:bg-gray-400/30 h-11" />
        </div>
        <div className="col-span-2 sm:col-span-1">
          <div className="w-1/5 h-3.5 mb-2 bg-gray-400/60 dark:bg-gray-400/30  rounded" />
          <div className="rounded bg-gray-400/60 dark:bg-gray-400/30 h-11 " />
        </div>
        <div className="col-span-2">
          <div className="w-1/5 h-3.5 mb-2 bg-gray-400/60 dark:bg-gray-400/30  rounded" />
          <div className="rounded bg-gray-400/60 dark:bg-gray-400/30 h-11 " />
        </div>
        <div className="col-span-2">
          <div className="w-1/5 h-3.5 mb-2 bg-gray-400/60 dark:bg-gray-400/30  rounded" />
          <div className="rounded bg-gray-400/60 dark:bg-gray-400/30 h-11" />
        </div>
      </div>
      <div className="w-3/4 h-4 mt-6 rounded bg-gray-400/60 dark:bg-gray-400/30" />
    </>
  );
}
